import { uniqueId } from 'lodash';

export const initialStateImpostos = () => ({
  tipoAplicacaoIcms: null,
  tipoAplicacaoIpi: null,
  icms: 0,
  ipi: 0,
});

export const initalStateProduto = () => ({
  $$id: uniqueId(),
  produto: null,
  quantidade: null,
  arquivos: [],
  unidadeMedida: {
    id: null,
    descricao: null,
  },
  especificacaoProduto: null,
  observacaoInterna: null,
  observacaoExterna: null,
  centroCusto: null,
  projeto: null,
  precoUnitario: null,
  tipoNotaEntrada: null,
  cfop: null,
  cadastrosAdicionais: null,
  impostos: initialStateImpostos(),
  $$itemTabelaPreco: null,
});

export const mapValoresTabelaPreco = (produto, itemTabelaPreco, isAVista) => ({
  ...produto,
  // adicionamos o item da tabela no produto para facilitar
  // a troca de valores e computar outros campos
  $$itemTabelaPreco: itemTabelaPreco,
  precoUnitario: isAVista ? itemTabelaPreco.precoAVista : itemTabelaPreco.precoAPrazo,
  impostos: {
    ...produto.impostos,
    icms: itemTabelaPreco.icms,
    ipi: itemTabelaPreco.ipi,
  },
});
